export default __webpack_public_path__ + "9b828d6db2d51f5dfc62fedbd33b2bb5.png";